import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { environment } from '../../../../../../environments/environment';

@Component({
    selector: 'app-help-desk-successful-request',
    templateUrl: './call-help-desk-successful-request.component.html',
    styleUrls: ['./call-help-desk-successful-request.component.scss'],
    standalone: false
})
export class HelpDeskSuccessfulRequestComponent implements OnInit, AfterViewInit {
  constructor(private router: Router) {}

  readonly directChannel: boolean = environment.directChannel;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    window.scrollTo(0, 0);
  }

  goToHome() {
    this.router.navigate([
      RoutePath.HOME
    ]);
  }

  goToHelpDeskList() {
    this.router.navigate([RoutePath.BANDI, RoutePath.HELPDESK_LIST]);
  }
}
